import { memo } from 'react';
import Layout from '@/shared/Layout/ui/Layout';
import Head from 'next/head';
import { Container } from '@/common/ui/containers/Container/Container';
import Voucher from './Voucher/Voucher';
import { useGetOrder } from '../app/useGetOrder';
import { Preloader } from '@/common/ui/loaders/Preloader';
import { Wrapper } from './OrdersPage.styles';

const OrderVoucherContainer = () => {
    const { order, loading, voucher } = useGetOrder({ voucherRequired: true });

    return (
        <Layout>
            <Head>
                <title>Voucher - TripShock!</title>
                <meta name="description" key="description" content="" />
            </Head>
            <Wrapper>
                <Container>
                    {loading && <Preloader minHeight="calc(100vh - 50px)" />}
                    {order && voucher && !loading && <Voucher voucher={voucher} order={order} />}
                </Container>
            </Wrapper>
        </Layout>
    );
};

export const OrderVoucher = memo(OrderVoucherContainer);
